<template>
    <div class="salepage-product__detail tw-flex tw-justify-center" v-if="productDetailOpen">
        <div class="salepage-product__detail--shade" @click="closeModal()">
        </div>
        <div class="salepage-product__detail--body tw-rounded-2xl tw-rounded-b-none" :style="productDetailTransition ? 'transform: translateY(0);' : ''">
            <div 
                class="salepage-product__detail--modal-header tw-flex tw-justify-between border-section tw-pt-5 tw-mx-6 tw-pb-4 tw-rounded-2xl tw-rounded-b-none"
                width="100%"
            >
                <div class="tw-text-xl tw-text-bold">
                    รายละเอียดสินค้า
                </div>
                <div class="btn text-2xl tw-px-2 tw-py-1 tw-rounded-lg salepage-product__detail--close-button" :style="styleObject"
                    @click="closeModal()">
                    <i class="fa fa-close"></i>
                </div>
            </div>

            <div
                class="salepage-product__detail--modal-body tw-px-6 tw-mb-4 tw-mt-4 tw-grid tw-gap-2 tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 md:tw-gap-5">
                <!-- <div class="tw-col-span-1 tw-w-full tw-flex tw-justify-center image-detail-container">
                    <img class="tw-w-full image-detail" :src="product.image_url" />
                </div> -->
                <div class="tw-col-span-1 image-container tw-rounded-lg m-2">
                    <img :src="product.image_url" class="image-detail tw-w-full tw-rounded-lg tw-flex tw-justify-center" :alt="product.name" />
                </div>
                <div class="tw-col-span-1 lg:tw-col-span-2 ">
                    <div class="mb-3">
                        <h3>
                            {{ product.name }}
                        </h3>
                        <div>
                            <div>
                                <small 
                                    v-if="parseFloat(product.price) < parseFloat(product.price_full)" 
                                    class="tw-text-red-500 tw-text-xl tw-tracking-tight tw-font-semibold tw-font-sans"
                                >
                                    {{ currency ? currency.symbol : "" }} {{
                                        Number(product.price).toLocaleString(undefined, {
                                            minimumFractionDigits: 2
                                        })
                                    }}
                                </small>
                                <small v-if="parseFloat(product.price) >=
                                        parseFloat(product.price_full)
                                        " class="tw-text-black tw-text-xl tw-tracking-tight tw-font-semibold tw-font-sans">
                                    {{ currency ? currency.symbol : "" }} {{
                                        Number(product.price).toLocaleString(undefined, {
                                            minimumFractionDigits: 2
                                        })
                                    }}
                                </small>
                            </div>
                            <div>
                                <small v-if="parseFloat(product.price) <
                                        parseFloat(product.price_full)
                                        " class="tw-line-through tw-text-base tw-tracking-tight tw-font-sans">
                                    {{ currency ? currency.symbol : "" }} {{
                                        Number(product.price_full).toLocaleString(
                                            undefined,
                                            {
                                                minimumFractionDigits: 2
                                            }
                                        )
                                    }}
                                </small>
                            </div>
                        </div>
                    </div>
                    <div class="tw-mb-5">
                        <div class="tw-overflow-auto tw-h-40" v-html="product.description">
                        </div>
                    </div>

                    <div class="non-mobile salepage-product__detail--modal-footer tw-py-2" height="20px">
                        <div>
                            <div class="tw-flex">
                                <div>
                                <div
                                    v-if="parseFloat(product.stock_balance) > 0" 
                                    class="quantity-selector tw-mr-3 tw-items-center tw-rounded-2xl tw-flex tw-justify-around tw-text-bold tw-h-8"
                                    :style="styleObject"
                                    style="width: 125px;"
                                >
                                    <div class="tw-text-right pl-3 tw-cursor-pointer tw-self-center" @click="quantity = quantity - 1">
                                        <i class="fa fa-minus"></i>
                                    </div>
                                    <div 
                                        class="tw-text-center tw-mx-2 tw-px-2"
                                        style="border-left: 1px solid #dedede; border-right: 1px solid #dedede"
                                    >
                                        <input type="number" v-model="quantity" />
                                    </div>
                                    <div class="tw-text-left pr-3 tw-cursor-pointer tw-self-center" @click="quantity = quantity + 1">
                                        <i class="fa fa-plus"></i>
                                    </div>
                                </div>
                                <div class="tw-text-sm tw-text-secondary tw-mt-3">
                                    (มีในตะกร้า {{ queueQuantity }} ชิ้น)
                                </div>
                            </div>
                                <div class="" >
                                    <button 
                                        v-if="parseFloat(product.stock_balance) <= 0" 
                                        class="btn btn-light tw-rounded-full tw-w-full tw-text-xs" 
                                        disabled
                                    >
                                        สินค้าหมด
                                    </button>
                                    <button
                                        v-else
                                        type="button"
                                        class="btn tw-rounded-full tw-text-xs tw-h-8"
                                        :style="`background-color:${salePage.button_color}; color: ${salePage.button_text};`"
                                        style="width: 125px;"
                                        @click="addtoCart(product.id, quantity)"
                                    >
                                        <div class="tw-text-md tw-flex tw-justify-center tw-self-center">
                                            <div><i class="fa fa-shopping-bag mr-2"></i>เพิ่มสินค้า</div>
                                        </div>
                                    </button>
                                </div>
                            </div>
                            <div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mobile salepage-product__detail--modal-footer tw-p-2">
                <div>
                    <div class="tw-flex tw-justify-around tw-px-2">
                        <div class="tw-w-1/2 tw-mx-1" style="max-width: 150px;">
                            <div
                                v-if="parseFloat(product.stock_balance) > 0" 
                                class="quantity-selector tw-mr-3 tw-w-full tw-rounded-2xl tw-flex tw-justify-around tw-text-bold tw-h-8"
                                :style="styleObject"
                            >
                                <div class="tw-text-right tw-ml-2 tw-cursor-pointer tw-self-center" @click="quantity = quantity - 1">
                                    <i class="fa fa-minus"></i>
                                </div>
                                <div class="tw-text-md tw-self-center tw-text-center tw-px-2" style="width: 50px; border-left: 1px solid #dedede; border-right: 1px solid #dedede">
                                    <input type="number" v-model="quantity" />
                                </div>
                                <div class="tw-text-left tw-mr-2 tw-cursor-pointer tw-self-center" @click="quantity = quantity + 1">
                                    <i class="fa fa-plus"></i>
                                </div>
                            </div>
                            <div class="tw-text-sm tw-text-secondary tw-mt-1">
                                (มีในตะกร้า {{ queueQuantity }} ชิ้น)
                            </div>
                        </div>
                        <div class="tw-w-1/2 tw-mx-1 tw-flex tw-justify-center" style="max-width: 150px;">
                            <button 
                                v-if="parseFloat(product.stock_balance) <= 0" 
                                class="btn btn-light tw-rounded-full tw-w-full tw-text-xs" 
                                disabled
                            >
                                สินค้าหมด
                            </button>
                            <button
                                v-else
                                type="button"
                                class="btn tw-flex tw-justify-center tw-rounded-full tw-w-full tw-h-8"
                                :style="`background-color:${salePage.button_color}; color: ${salePage.button_text};`"
                                style="max-width: 150px;"
                                @click="addtoCart(product.id, quantity)"
                            >
                                <div class="tw-text-md tw-self-center">
                                    <div><i class="fa fa-shopping-bag mr-2"></i>เพิ่มสินค้า</div>
                                </div>
                            </button>
                        </div>
                    </div>
                    <div>
                       
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    props: ["productDetailOpen", "product", "salePage", "currency", "queueQuantity"],
    data() {
        return {
            productDetailTransition: false,
            quantity: 1,
            totalPrice: 0,
        }
    },
    methods: {
        closeModal() {
            this.productDetailTransition = false;
            this.quantity = 1;
            this.totalPrice = 0;
            setTimeout(() => {
                this.$emit("closeProductDetail");
            }, 400);
        },
        addtoCart(productId, quantity) {
            this.$emit("addToCart", productId, quantity);
            this.closeModal();
        }
    },
    computed: {
        styleObject: function () {
            return {
                '--button-color': this.salePage.button_color,
                '--button-text': this.salePage.button_text
            }
        }
    },
    watch: {
        productDetailOpen: function (value) {
            if (value) {

                setTimeout(() => {
                    this.productDetailTransition = true;
                }, 100);
            }
        },   
        quantity: function (value) {
            if (value < 1) {
                this.quantity = 1;
            } else if (value > this.product.stock_balance - this.queueQuantity) {
                this.quantity = this.product.stock_balance - this.queueQuantity;
            }
        }
    },
}
</script>
<style scoped>

input {
    border: 0;
    outline: 0;
    width: 70%;
    text-align: center;
}

input:focus {
    outline: none!important;
}


.salepage-product__detail--close-button {
    border: 1px solid var(--button-color);
}

.salepage-product__detail--close-button:hover {
    background-color: var(--button-color);
    color: var(--button-text);
}
.border-section {
    border-bottom: 2px solid #dedede;
}

.quantity-selector {
    border: 1px solid var(--button-color);
}
.salepage-product__detail {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 9997;
}

.salepage-product__detail--shade {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.5;
    z-index: 9998;
}

.salepage-product__detail--body {
    position: absolute;
    opacity: 100%;
    margin: 0;
    bottom: 0;
    background-color: #fff;

    z-index: 9999;
    transition: all 0.5s ease;
    transform: translateY(100%);
}

.shadow-overlay:hover {
    box-shadow: inset 0 0 0 20000px rgba(0, 0, 0, 0.25);
    transition: all 0.25s ease;
}

.image-container {
    width: 100%;
    aspect-ratio: 1 / 1;
}

.image-container img {
    height: 100%;
    width: 100%;
    object-fit: cover;
}

/* Input without browser appearance */
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

@media screen and (max-width: 768px) {
    .salepage-product__detail--body {
        width: 100%;
    }
    .mobile {
        display: block;
    }

    .non-mobile {
        display: none;
    }

    .image-container {
        width: 50%;
        aspect-ratio: 1 / 1;
    }
    
            
}

@media screen and (min-width: 769px) {
    .salepage-product__detail--body {
        max-height: 600px;
        width: 70%;
    }

    .mobile {
        display: none;
    }

    .non-mobile {
        display: block;
    }

}
</style>